import { render, staticRenderFns } from "./SalPaySearch.vue?vue&type=template&id=a70227b4&scoped=true"
import script from "./SalPaySearch.vue?vue&type=script&lang=js"
export * from "./SalPaySearch.vue?vue&type=script&lang=js"
import style0 from "./SalPaySearch.vue?vue&type=style&index=0&id=a70227b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70227b4",
  null
  
)

export default component.exports